import createGetFormInitialValues from './selectors/getFormInitialValues';
import plain from './structure/plain';

export default createGetFormInitialValues(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/getFormInitialValues.js
// module id = 2258
// module chunks = 2